
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			aria-labelledby={`full-width-tab-${index}`}
			{...other}
		>
		{value === index && (
			<Box p={3}>
				<Typography>{children}</Typography>
			</Box>
		)}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
}));

class SwipeableTabs extends Component {
    state = {
        value: this.props.tab || 0 ,
        index: this.props.tab || 0
    }
	
    handleChange = (e, value) => {

		this.props.returnIndex && this.props.returnIndex(value)
        this.setState({
            value
        })
    };
    handleChangeIndex = (index) => {
		this.props.returnIndex && this.props.returnIndex(index)
        this.setState({
            index
        })
    };

    render() {
        const {value, index} = this.state;
		const {searchPaper} = this.props;
        return (
			<Box >
				{/* <AppBar position="static" color="default"> */}
				<Tabs
					value={value}
					onChange={this.handleChange}
					indicatorColor="primary"
					textColor="primary"
					variant="fullWidth"
					aria-label="full width tabs example"
				>
				{this.props.labels.map( (label, i) => (
					<Tab label={label} {...a11yProps(i)} />
				))}
				</Tabs>
				{/* </AppBar> */}
				{searchPaper}
				<SwipeableViews
					axis={'x'}
					index={value}
					onChangeIndex={this.handleChangeIndex}
				>
					{this.props.children}	
				</SwipeableViews>
			</Box>
        );
    }
}

export default SwipeableTabs;
